"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var strongly_type_resolver_1 = require("./strongly-type.resolver");

var RichTextResolver =
/** @class */
function () {
  function RichTextResolver() {}
  /**
   * Resolves linked items inside the Rich text field.
   * Rich text resolved needs to be configured either on the model or query level
   */


  RichTextResolver.prototype.resolveHtml = function (html, fieldName, data) {
    var _this = this; // prepare config


    var config = {
      enableAdvancedLogging: data.enableAdvancedLogging,
      queryConfig: data.queryConfig,
      linkedItemWrapperTag: data.linkedItemWrapperTag,
      linkedItemWrapperClasses: data.linkedItemWrapperClasses
    };
    var result = data.richTextHtmlParser.resolveRichTextField(html, fieldName, {
      getLinkResult: function getLinkResult(itemId, linkText) {
        return _this.getLinkResult({
          config: config,
          links: data.links,
          itemId: itemId,
          typeResolvers: data.typeResolvers,
          linkText: linkText
        });
      },
      getLinkedItemHtml: function getLinkedItemHtml(itemCodename, itemType) {
        return _this.getLinkedItemHtml({
          itemCodename: itemCodename,
          config: config,
          getLinkedItem: data.getLinkedItem,
          itemType: itemType
        });
      },
      getImageResult: function getImageResult(imageId) {
        return _this.getImageResult({
          config: config,
          imageId: imageId,
          images: data.images,
          html: html,
          fieldName: fieldName
        });
      }
    }, {
      enableAdvancedLogging: data.enableAdvancedLogging,
      queryConfig: data.queryConfig,
      linkedItemWrapperTag: data.linkedItemWrapperTag,
      linkedItemWrapperClasses: data.linkedItemWrapperClasses
    });
    return result.resolvedHtml;
  };

  RichTextResolver.prototype.getImageResult = function (data) {
    // find image
    var image = data.images.find(function (m) {
      return m.imageId === data.imageId;
    });

    if (!image) {
      throw Error("Image with id '" + data.imageId + "' was not found in images data");
    } // use custom resolver if present


    if (data.config.queryConfig.richTextImageResolver) {
      return data.config.queryConfig.richTextImageResolver(image, data.fieldName);
    } // use default resolver


    return {
      url: image.url
    };
  };

  RichTextResolver.prototype.getLinkedItemHtml = function (data) {
    // get linked item
    var linkedItem = data.getLinkedItem(data.itemCodename); // resolving cannot be done if the item is not present in response

    if (!linkedItem) {
      throw Error("Linked item with codename '" + data.itemCodename + "' could not be found in response and therefore the HTML of rich text field could not be evaluated. Increasing 'depth' parameter of your query may solve this issue.");
    } // get html to replace object using Rich text resolver function


    var resolver = undefined;

    if (data.config.queryConfig.richTextResolver) {
      // use resolved defined by query if available
      resolver = data.config.queryConfig.richTextResolver;
    } else {
      // use default resolver defined in models
      if (linkedItem.richTextResolver) {
        resolver = linkedItem.richTextResolver;
      }
    } // check resolver


    if (!resolver) {
      if (data.config.enableAdvancedLogging) {
        console.warn("Cannot resolve html of '" + linkedItem.system.type + "' type in 'RichTextField' because no rich text resolved was configured.  This warning can be turned off by disabling 'enableAdvancedLogging' option.");
        return '';
      }

      return '';
    }

    return resolver(linkedItem, {
      contentType: data.itemType
    });
  };

  RichTextResolver.prototype.getLinkResult = function (data) {
    // find link with the id of content item
    var link = data.links.find(function (m) {
      return m.linkId === data.itemId;
    });

    if (!link) {
      if (data.config.enableAdvancedLogging) {
        console.warn("Cannot resolve URL for item '" + data.itemId + "' because no link with this id was found. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
      }

      return '';
    } // try to resolve link using the resolver passed through the query config


    var queryLinkResolver = data.config.queryConfig.linkResolver;
    var url; // prepare link context

    var linkContext = {
      linkText: data.linkText
    };

    if (queryLinkResolver) {
      // try to resolve url using the query config
      url = queryLinkResolver(link, linkContext);
    }

    if (!url) {
      // url was not resolved, try to find global resolver for this particular type
      var emptyTypedItem = strongly_type_resolver_1.stronglyTypedResolver.createEmptyTypedObj(link.type, data.typeResolvers);

      if (!emptyTypedItem) {
        if (data.config.enableAdvancedLogging) {
          console.warn("Cannot resolve link for link of '" + link.type + "' type with id '" + link.linkId + "' and url slug '" + link.urlSlug + "'. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
        }
      } else {
        var globalLinkResolver = emptyTypedItem.linkResolver;

        if (globalLinkResolver) {
          url = globalLinkResolver(link, linkContext);
        }
      }
    } // url still wasn't resolved


    if (!url) {
      if (data.config.enableAdvancedLogging) {
        console.warn("Url for content type '" + link.type + "' with id '" + link.linkId + "' resolved to null/undefined. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
      }

      return '';
    }

    return url;
  };

  return RichTextResolver;
}();

exports.RichTextResolver = RichTextResolver;
exports.richTextResolver = new RichTextResolver();